import React, { useContext, useState } from 'react'
import { Box, Text, Stack, Diagram, Anchor } from "grommet"

import axios from 'axios'
import TTJsonTree from '../common/TTJsonTree'
import TTCopyClipboard from '../common/TTCopyClipboard'
import { gql, useSubscription } from '@apollo/client';
import UserContext from '../../context/UserContext'
import TriageUrlContext from '../../context/TriageUrlContext'

import * as moment from "moment-timezone"
import * as beautify from "json-beautify"
import { useDefaultConf } from './TriageHeaders'

function processStatus(status) {
    if (status === "Not Started") {
        return "light-4"
    } else if (status === "Skipped" || status === "Completed") {
        return "ttok"
    } else if (status === "In Progress") {
        return "#FF8800"
    } else if (status === "Partial") {
        return "ttpartial"
    }
}

function procressTimeStamp(timestamp, token) {
    let timestamp_temp = ''
    timestamp_temp = moment(moment(timestamp).format('YYYY-MM-DD HH:mm:ss.SSS') + " +0000").tz('UTC').format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
    timestamp_temp = moment(timestamp_temp).tz(token.timezone).format('YYYY-MM-DD HH:mm:ss.SSS ZZ')
    return timestamp_temp
}

const TriageTaskResultView = ({taskid}) => {

    const TASK_QUERY = gql`
    subscription($taskId: String!) {
        jobtask(where: {taskid: {_eq: $taskId}}) {
            taskid
            result
            status
          }
    }
    `

    const [result, setResult] = useState(false)
    const [state, setState] = useState(false)
    const axiosConf = useDefaultConf()

    const t3_url = useContext(TriageUrlContext)

    const { data: taskResult, loading: taskDataLoading } = useSubscription(
        TASK_QUERY, { variables: { taskId: taskid } }
    )

    let t3TaskStatus = t3_url + '/api/1/taskstatus/' + taskid

    async function getStatusResponse() {

        const response = await axios(t3TaskStatus, axiosConf)

        if (response.status === 200) {
            if (response.data.state === "SUCCESS") {
                setResult(response.data)
                setState(response.data.state)
                return null
            }
            if (response.data.state === "PENDING") {
                setResult(response.data)
                setState(response.data.state)
                return null
            }
            if (response.data.state === "FAILURE") {
                setResult(response.data)
                setState(response.data.state)
                return null
            }
        }

    }

    if (!taskDataLoading && taskResult && taskResult.jobtask &&
        taskResult.jobtask.length > 0 && taskResult.jobtask[0].status !== 0
        && !(taskid.includes("MANUAL")) && state === false
        ) {
        getStatusResponse()
    }

    return (
        <Box>
            {result && result.state === "SUCCESS" && <Text size="small" weight="bold" color="ttok">Task Completed</Text> }
            {result && result.results && result.results.failed_order_ids && result.results.failed_order_ids.length > 0 && 
                <>
                    <Box direction="row" >
                        <Text size="small" weight="bold" color="ttdown">Failed Order IDs</Text>
                        <TTCopyClipboard copyText={beautify(result.results.failed_order_ids)} />
                    </Box>
                    <Box overflow={{ horizontal: 'hidden', vertical: 'auto' }} height="200px">
                        <TTJsonTree data={result.results.failed_order_ids} />
                    </Box>
                </>
            }
            {result && result.results && result.results.failed_order_ids && result.results.failed_order_ids.length === 0 && 
                <>
                    <Text size="small" weight="bold" color="ttok">No Failed Order IDs</Text>
                </>
            }
        </Box>
    )

}

export const ProgressView = ({ content, token }) => {

    const JOB_LOG_QUERY = gql`
    subscription($taskId: String!) {
        jobtasklog(where: {taskid: {_eq: $taskId}}, order_by: {timestamp: asc}) {
            timestamp
            logginglevel
            message
          }
    }
    `

    const { data: logData, loading: logDataLoading } = useSubscription(
        JOB_LOG_QUERY, { variables: { taskId: content.taskid } }
    )

    const defaultState = {
        0: "Not Started",
        1: "Not Started",
        2: "Not Started",
        3: "Not Started",
        4: "Not Started",
        5: "Not Started"
    }
    const defaultStateTimeStart = {
        0: null,
        1: null,
        2: null,
        3: null,
        4: null,
        5: null
    }
    const defaultStateTimeEnd = {
        0: null,
        1: null,
        2: null,
        3: null,
        4: null,
        5: null
    }

    const [jobProgress, setJobProgress] = useState(defaultState)
    const [jobProgressTimeStart, setJobProgressTimeStart] = useState(defaultStateTimeStart)
    const [jobProgressTimeEnd, setJobProgressTimeEnd] = useState(defaultStateTimeEnd)
    const [execReports, setExecReports] = useState(null)
    const [step5Status, setStep5Status] = useState(null)

    if (!logDataLoading && logData) {

        let newState = defaultState
        let newStateTimeStart = defaultStateTimeStart
        let newStateTimeEnd = defaultStateTimeEnd

        logData.jobtasklog.forEach(log => {

            const timestamp_parsed = procressTimeStamp(log.timestamp, token)

            // Step 0 
            if (log.message.indexOf("Cassandra Reaper - Starting") > -1) {
                newState[0] = "In Progress"
                newStateTimeStart[0] = timestamp_parsed
            }
            if (log.message.indexOf("Cassandra Reaper - Skipped") > -1) {
                newState[0] = "Skipped"
                newStateTimeStart[0] = timestamp_parsed
                newStateTimeEnd[0] = timestamp_parsed
            }
            if (log.message.indexOf("Cassandra Reaper - Completed") > -1) {
                newState[0] = "Completed"
                newStateTimeEnd[0] = timestamp_parsed
            }

            // Step 1
            if (log.message.indexOf("Cassandra Compaction - Starting") > -1) {
                newState[1] = "In Progress"
                newStateTimeStart[1] = timestamp_parsed
            }
            if (log.message.indexOf("Cassandra Compaction - Skipped") > -1) {
                newState[1] = "Skipped"
                newStateTimeStart[1] = timestamp_parsed
                newStateTimeEnd[1] = timestamp_parsed
            }
            if (log.message.indexOf("Cassandra Compaction - Completed") > -1) {
                newState[1] = "Completed"
                newStateTimeEnd[1] = timestamp_parsed
            }

            // Step 2
            if (log.message.indexOf("LedgerWeb Download - Starting") > -1) {
                newState[2] = "In Progress"
                newStateTimeStart[2] = timestamp_parsed
            }
            if (log.message.indexOf("LedgerWeb Download - Completed") > -1) {
                newState[2] = "Completed"
                newStateTimeEnd[2] = timestamp_parsed
            }

            // Step 3
            if (log.message.indexOf("Replay Execution Reports - Starting") > -1) {
                newState[3] = "In Progress"
                newStateTimeStart[3] = timestamp_parsed
            }
            if (log.message.indexOf("Replay Execution Reports - Completed") > -1) {
                newState[3] = "Completed"
                newStateTimeEnd[3] = timestamp_parsed
            }
            if (!execReports && log.message.indexOf("Execution Reports from LedgerWeb") > -1) {
                setExecReports(log.message.split(" ")[1])
            }

            // Step 4
            if (log.message.indexOf("Cassandra Orderbook/Orderdata Indexing - Starting") > -1) {
                newState[4] = "In Progress"
                newStateTimeStart[4] = timestamp_parsed
            }
            if (log.message.indexOf("Cassandra Orderbook/Orderdata Indexing - Completed") > -1) {
                if (newState[4] !== "Partial") {
                    newState[4] = "Completed"
                    newStateTimeEnd[4] = timestamp_parsed
                }
            }
            if (!step5Status && log.message.indexOf("orders not processed") > -1) {
                newState[4] = "Partial"
                newStateTimeEnd[4] = timestamp_parsed
                setStep5Status(log.message.split(" ")[4])
            }

            // Step 5
            if (log.message.indexOf("Trigger OBDL - Starting") > -1) {
                newState[5] = "In Progress"
                newStateTimeStart[5] = timestamp_parsed
            }
            if (log.message.indexOf("Trigger OBDL - Completed") > -1) {
                newState[5] = "Completed"
                newStateTimeEnd[5] = timestamp_parsed
            }
        });

        // Set New State Only IF there are changes otherwise will have re render problems
        if (JSON.stringify(newState) !== JSON.stringify(jobProgress)) {
            setJobProgress(newState)
            setJobProgressTimeStart(newStateTimeStart)
            setJobProgressTimeEnd(newStateTimeEnd)
        }
    }

    return (
        <Box>
            <Box direction="column" width="800px" margin={{left: "15px"}}>
                <TriageTaskResultView taskid={content.taskid} />
            </Box>

            <Stack guidingChild={1}>
                <Diagram
                    connections={[
                        {
                            fromTarget: '0',
                            toTarget: '1',
                            thickness: 'xsmall',
                            color: 'black',
                        },
                        {
                            fromTarget: '1',
                            toTarget: '2',
                            thickness: 'xsmall',
                            color: 'black',
                        },
                        {
                            fromTarget: '2',
                            toTarget: '3',
                            thickness: 'xsmall',
                            color: 'black',
                        },
                        {
                            fromTarget: '3',
                            toTarget: '4',
                            thickness: 'xsmall',
                            color: 'black',
                        },
                        {
                            fromTarget: '4',
                            toTarget: '5',
                            thickness: 'xsmall',
                            color: 'black',
                        },
                    ]}
                />
                <Box direction="row" wrap={true} width="800px">
                <Box direction="row" margin={{top: "20px"}}>
                        <Box id="0" width="325px" margin="small" pad="small" background={processStatus(jobProgress[0])} animation={jobProgress[0] === "In Progress" ? 'pulse' : 'fadeIn'}>
                            <Text size="small" weight="bold">{jobProgress[0] === "Skipped" ? "1: Cassandra Reaper (Skipped)" : "1: Cassandra Reaper"}</Text>
                            <Text size="xsmall">Running repair with reaper</Text>
                            <Text size="xsmall">Duration: {(moment(jobProgressTimeEnd[0]) - moment(jobProgressTimeStart[0]))/1000} seconds</Text>
                            <Text size="xsmall">Start: {jobProgressTimeStart[0]}</Text>
                            <Text size="xsmall">End: {jobProgressTimeEnd[0]}</Text>
                        </Box>
                    </Box>
                    <Box direction="row" margin={{top: "20px"}}>
                        <Box id="1" width="325px" margin="small" pad="small" background={processStatus(jobProgress[1])} animation={jobProgress[1] === "In Progress" ? 'pulse' : 'fadeIn'}>
                            <Text size="small" weight="bold">{jobProgress[1] === "Skipped" ? "2: Cassandra Compaction (Skipped)" : "2: Cassandra Compaction"}</Text>
                            <Text size="xsmall">Running compaction against Cassandra</Text>
                            <Text size="xsmall">Duration: {(moment(jobProgressTimeEnd[1]) - moment(jobProgressTimeStart[1]))/1000} seconds</Text>
                            <Text size="xsmall">Start: {jobProgressTimeStart[1]}</Text>
                            <Text size="xsmall">End: {jobProgressTimeEnd[1]}</Text>
                        </Box>
                    </Box>
                    <Box direction="row" margin={{top: "20px"}}>
                        <Box id="3" width="325px" margin="small" pad="small" background={processStatus(jobProgress[3])} animation={jobProgress[3] === "In Progress" ? 'pulse' : 'fadeIn'}>
                            <Text size="small" weight="bold">4. Replay Execution Report</Text>
                            <Text size="xsmall">Replaying ERs via LBM</Text>
                            <Text size="xsmall">Duration: {(moment(jobProgressTimeEnd[3]) - moment(jobProgressTimeStart[3]))/1000} seconds</Text>
                            <Text size="xsmall">Start: {jobProgressTimeStart[3]}</Text>
                            <Text size="xsmall">End: {jobProgressTimeEnd[3]}</Text>
                        </Box>
                    </Box>
                    <Box direction="row" margin={{top: "20px"}}>
                        <Box id="2" width="325px" margin="small" pad="small" background={processStatus(jobProgress[2])} animation={jobProgress[2] === "In Progress" ? 'pulse' : 'fadeIn'}>
                            <Text size="small" weight="bold">3. LedgerWeb Download {execReports ? "("+execReports+" ERs Downloaded)" : null}</Text>
                            <Text size="xsmall">Downloading ERs from LedgerWeb</Text>
                            <Text size="xsmall">Duration: {(moment(jobProgressTimeEnd[2]) - moment(jobProgressTimeStart[2]))/1000} seconds</Text>
                            <Text size="xsmall">Start: {jobProgressTimeStart[2]}</Text>
                            <Text size="xsmall">End: {jobProgressTimeEnd[2]}</Text>
                        </Box>
                    </Box>
                    <Box direction="row" margin={{top: "20px"}}>
                        <Box id="4" width="325px" margin="small" pad="small" background={processStatus(jobProgress[4])} animation={!step5Status && jobProgress[4] === "In Progress" ? 'pulse' : 'fadeIn'}>
                            <Text size="small"weight="bold">5. Cassandra Orderbook/Orderdata Indexing {step5Status ? "("+step5Status+" Orders Not Processed)" : null}</Text>
                            <Text size="xsmall">Adding Indexing for Replayed ERs</Text>
                            <Text size="xsmall">Duration: {(moment(jobProgressTimeEnd[4]) - moment(jobProgressTimeStart[4]))/1000} seconds</Text>
                            <Text size="xsmall">Start: {jobProgressTimeStart[4]}</Text>
                            <Text size="xsmall">End: {jobProgressTimeEnd[4]}</Text>
                        </Box>
                    </Box>
                    <Box direction="row" margin={{top: "20px"}}>
                        <Box id="5" width="325px" margin="small" pad="small" background={processStatus(jobProgress[5])} animation={jobProgress[5] === "In Progress" ? 'pulse' : 'fadeIn'}>
                            <Text size="small" weight="bold">6. Trigger OBDL</Text>
                            <Text size="xsmall">Trigger OC to do Orderbook Download</Text>
                            <Text size="xsmall">Duration: {(moment(jobProgressTimeEnd[5]) - moment(jobProgressTimeStart[5]))/1000} seconds</Text>
                            <Text size="xsmall">Start: {jobProgressTimeStart[5]}</Text>
                            <Text size="xsmall">End: {jobProgressTimeEnd[5]}</Text>
                        </Box>
                    </Box>
                </Box>
            </Stack>
        </Box>
    )
}

export const TriageViewLogHistory = ({ content }) => {

    const token = useContext(UserContext)

    return (

        <>
            <Text margin={{ left: "small" }} size="small">
                <Anchor target="_blank" href={"/orderrestatestatus/"+content.taskid} primary label={<Text size="small" color="dark-3" margin={{ top: "xsmall", bottom: "xsmall" }}>{"Sharable Progress Link"}</Text>} />
            </Text>

            <ProgressView
                content={content}
                token={token}
            />
        </>
    )
}

export default TriageViewLogHistory
